module.exports = __webpack_public_path__ + "media/images/favicon-21fbd5924fc7305ca887e64a30c74807.svg";